import { render } from "./TutiSwiper.vue?vue&type=template&id=05a5b55b&scoped=true"
import script from "./TutiSwiper.vue?vue&type=script&lang=js"
export * from "./TutiSwiper.vue?vue&type=script&lang=js"

import "./TutiSwiper.vue?vue&type=style&index=0&id=05a5b55b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a5b55b"]])

export default __exports__